import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const ServiceFeatureItem: React.FC<{text: string}> = ({text}) => {
  return (
    <li className="service-feature-item">
      <span className="feature-check">✓</span>
      <span>{text}</span>
    </li>
  );
};

// 服务卡片组件，包含展开/折叠功能
const ServiceCard: React.FC<{
  icon: string;
  titleKey: string;
  descKey: string;
  featuresKey: string;
  cardClass: string;
}> = ({ icon, titleKey, descKey, featuresKey, cardClass }) => {
  const [expanded, setExpanded] = useState(false);
  // @ts-ignore
  const { t } = useTranslation();

  return (
    <div className={`service-card ${cardClass}`}>
      <div className="service-header">
        <div className="service-icon">{icon}</div>
        {/* @ts-ignore */}
        <h3>{t(titleKey)}</h3>
      </div>
      {/* @ts-ignore */}
      <p className="service-description">{t(descKey)}</p>
      <div className="service-features">
        {/* @ts-ignore */}
        <h4>{t('services.key_features')}</h4>
        <ul className="features-list">
          {/* @ts-ignore */}
          {t(featuresKey, { returnObjects: true }).map((feature: string, index: number) => (
            <ServiceFeatureItem key={index} text={feature} />
          ))}
        </ul>
      </div>
      <div className="service-footer">
        <button 
          className="service-button" 
          onClick={() => setExpanded(!expanded)}
        >
          {/* @ts-ignore */}
          {expanded ? t('services.show_less') : t('services.learn_more')}
        </button>
        {expanded && (
          <div className="service-expanded-content">
            <p className="expanded-description">
              {/* @ts-ignore 这里可以根据需要添加更多详细内容 */}
              {t(`${descKey}_extended`, { defaultValue: t(descKey) })}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

const Services: React.FC = () => {
  // @ts-ignore
  const { t } = useTranslation();

  return (
    <div className="services-page">
      <div className="services-hero">
        {/* @ts-ignore */}
        <h1 className="services-hero-title">{t('services.title')}</h1>
        {/* @ts-ignore */}
        <p className="services-hero-subtitle">{t('services.subtitle')}</p>
        {/* @ts-ignore */}
        <p className="services-hero-intro">{t('services.intro')}</p>
      </div>

      <div className="page-container">
        <div className="services-grid">
          {/* 使用ServiceCard组件代替重复代码 */}
          <ServiceCard 
            icon="🧠" 
            titleKey="services.service1" 
            descKey="services.service1_desc" 
            featuresKey="services.service1_features" 
            cardClass="ai-service"
          />
          
          <ServiceCard 
            icon="⚙️" 
            titleKey="services.service2" 
            descKey="services.service2_desc" 
            featuresKey="services.service2_features" 
            cardClass="automation-service"
          />
          
          <ServiceCard 
            icon="📊" 
            titleKey="services.service3" 
            descKey="services.service3_desc" 
            featuresKey="services.service3_features" 
            cardClass="analytics-service"
          />
          
          <ServiceCard 
            icon="💬" 
            titleKey="services.service4" 
            descKey="services.service4_desc" 
            featuresKey="services.service4_features" 
            cardClass="nlp-service"
          />
          
          <ServiceCard 
            icon="☁️" 
            titleKey="services.service5" 
            descKey="services.service5_desc" 
            featuresKey="services.service5_features" 
            cardClass="aws-proxy-service"
          />
          
          <ServiceCard 
            icon="🔬" 
            titleKey="services.service6" 
            descKey="services.service6_desc" 
            featuresKey="services.service6_features" 
            cardClass="chip-design-service"
          />
        </div>

        <div className="services-cta-section">
          {/* @ts-ignore */}
          <h2>{t('services.cta')}</h2>
          {/* 将按钮替换为Link组件 */}
          <Link to="/contact" className="cta-button">
            {/* @ts-ignore */}
            {t('services.cta_button')}
          </Link>
        </div>

        <div className="services-companies">
          {/* @ts-ignore */}
          <h3>{t('services.trusted_by')}</h3>
          <div className="company-logos">
            {/* @ts-ignore */}
            <div className="company-logo">{t('services.company_types.fortune500')}</div>
            {/* @ts-ignore */}
            <div className="company-logo">{t('services.company_types.tech_innovators')}</div>
            {/* @ts-ignore */}
            <div className="company-logo">{t('services.company_types.global_enterprises')}</div>
            {/* @ts-ignore */}
            <div className="company-logo">{t('services.company_types.startups')}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services; 